import FrasesLayer from "../../components/preguntasTalento/FrasesLayer";

const FrasesPage = () => <FrasesLayer />;

export default FrasesPage;
